module.exports = __webpack_public_path__ + "static/media/upload_success.d7e317c4.png";